/**
 * API 게임사 name(영문) → 화면 표시용 한국어명
 * 백엔드 다국어 미지원 시 프론트에서 locale=ko 일 때 사용
 */
export const PROVIDER_NAME_PAIRS_KO = [
  ['PragmaticPlay', '프라그마틱 플레이'],
  ['Pragmatic Play', '프라그마틱 플레이'],
  ['PragmaticPlay(H)', '프라그마틱 플레이'],
  ['PragmaticPlay Live', '프라그마틱 플레이 라이브'],
  ['PragmaticPlay Live(H)', '프라그마틱 플레이 라이브'],
  ['Pragmatic Play Live', '프라그마틱 플레이 라이브'],
  ['Evolution', '에볼루션'],
  ['Evolution(H)', '에볼루션'],
  ['Evolution Gaming', '에볼루션'],
  ['Evolution2', '에볼루션'],
  ['Dream Game', '드림게임'],
  ['DreamGame', '드림게임'],
  ['Dream Gaming', '드림게이밍'],
  ['Asia Gaming', '아시아 게이밍'],
  ['MicroGaming', '마이크로게이밍'],
  ['MicroGaming Plus', '마이크로게이밍'],
  ['MicroGamingPlus', '마이크로게이밍'],
  ['MicroGamingPlusSlot', '마이크로게이밍'],
  ['MicroGaming Plus Slot', '마이크로게이밍 슬롯'],
  ['Sexy Gaming', '섹시 게이밍'],
  ['SexyBCRT', '섹시 게이밍'],
  ['Sexybcrt', '섹시 게이밍'],
  ['Ezugi', '이주기'],
  ['Booongo', '부운고'],
  ['Habanero', '하바네로'],
  ['PG Soft', 'PG 소프트'],
  ['PGSoft', 'PG 소프트'],
  ['NetEnt', '넷엔트'],
  ['PlayNGo', '플레이앤고'],
  ['Play N Go', '플레이앤고'],
  ['RedTiger', '레드타이거'],
  ['Red Tiger', '레드타이거'],
  ['Playson', '플레이슨'],
  ['Playtech', '플레이텍'],
  ['PlaytechSlot', '플레이텍 슬롯'],
  ['CQ9', 'CQ9'],
  ['Evoplay', '에보플레이'],
  ['GameArt', '게임아트'],
  ['Gamzix', '겜직스'],
  ['HacksawGaming', '헥소 게이밍'],
  ['Hacksaw Gaming', '헥소 게이밍'],
  ['NolimitCity', '노리밋 시티'],
  ['Nolimit City', '노리밋 시티'],
  ['RelaxGaming', '릴렉스 게이밍'],
  ['Relax Gaming', '릴렉스 게이밍'],
  ['BigTimeGaming', '빅타임 게이밍'],
  ['Big Time Gaming', '빅타임 게이밍'],
  ['BlueprintGaming', '블루프린트'],
  ['Blueprint Gaming', '블루프린트'],
  ['Thunderkick', '썬더킥'],
  ['Wazdan', '와즈단'],
  ['Yggdrasil', '위그드라실'],
  ['AvatarUX', '아바타 UX'],
  ['BetGamesTv', 'Betgames.tv'],
  ['Bgaming', 'B게이밍'],
  ['DragoonSoft', '드래곤소프트'],
  ['ELK', 'ELK'],
  ['Mobilots', '모바일럿'],
  ['Novomatic', '노보매틱'],
  ['PlayStar', '플레이 스타'],
  ['PlayPearls', '플레이펄'],
  ['ReelKingdom', '릴 킹덤'],
  ['SkyWindLive', '스카이윈드 라이브'],
  ['Skywind Live', '스카이윈드 라이브'],
  ['TriplePG', '트리플 PG'],
  ['1X2Gaming', '1x2 게이밍'],
  ['Bti', 'BTi'],
  ['BTi', 'BTi'],
  ['Spribe', '스프라이브']
]
